import { api } from '@api'
import { useLanguage } from '@context'
import { useQuery } from '@tanstack/react-query'
import { Profile } from './useGetProfile'

interface GetProfileByIdResponse {
  profile: Profile
}

const fetchProfileById = async (id: string, lang: string): Promise<Profile> => {
  const { data } = await api.get<GetProfileByIdResponse>(`/profile/${id}`, {
    params: { lang },
  })
  return data.profile
}

export const useGetProfileById = (id: string) => {
  const { currentLanguage } = useLanguage()
  return useQuery<Profile>({
    queryKey: ['profile', id, currentLanguage],
    queryFn: () => fetchProfileById(id, currentLanguage),
    enabled: !!id,
  })
}

